<template>
  <!-- POINT REPORT -->
  <v-flex d-flex class="section-2 general-bg" ma-0 py-2>
    <!-- LEFT SIDE -->
    <v-flex class="section-1" px-4>
      <!-- TITLE -->
      <h3 class="text-xs-left pt-2">Reporte por Punto</h3>        
      <!-- HEADER TEXT  -->
      <v-flex pt-3>
        Mueva el mapa usando como referencia el marcador <img :src="selectPointMarker" height="18px" alt="marker"> para elegir la posición a ser consultada. También puede escribir la coordenada. Opcional pude elegir un <b>Radio</b> entre 0m y 500m
      </v-flex>
      <!-- INDICATORS & CONTROLS -->
      <v-flex px-1>            
        <!-- POINT -->
        <v-flex d-flex align-center mt-3>
          <v-flex xs1 class="text-xs-center" pt-1>
            <img :src="selectPointMarker" height="32px" alt="marker">
          </v-flex>
          <v-flex xs11 pl-4>
            <v-flex>
              <v-text-field
                v-model="pointSelectedLat"
                name="lat"
                label="Lat"
                color="white"
                :rules="latRules"
                type="number"
                box
              >
              </v-text-field>
              <!-- <b>Lat:</b> {{ newCenter.lat.toFixed(5) }} -->
            </v-flex>
            <v-flex>
              <v-text-field
                v-model="pointSelectedLng"
                name="lng"
                label="Lng"
                color="white"
                :rules="lngRules"
                type="number"
                box
              >
              </v-text-field>
              <!-- <b>Lng:</b> {{ newCenter.lng.toFixed(5) }} -->
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- SLIDER RADIUS -->
        <v-flex py-1 px-3 mt-3 class="radius-style">
          <v-flex d-inline-flex align-center class="height-1">
            <v-flex pr-1>
              <b>Radio:</b>
            </v-flex>
            <v-text-field
              v-model="radius"
              class="radius-text ml-2"
              type="number">
            </v-text-field>
            <v-flex>
              m
            </v-flex>
          </v-flex>
          <v-flex class="slider-style">
            <v-slider
              v-model="radius"
              :max="500">
            </v-slider>
          </v-flex>
        </v-flex>
      </v-flex>
      <!-- DATE & TIME -->
      <v-flex mt-3>
        <!-- DATE INTERVAL FOR DATE1 & DATE2 -->
        <v-flex>
          <v-menu              
            lazy
            ref="menu"
            v-model="menu"
            transition="scale-transition"
            :close-on-content-click="false"
            :return-value.sync="dates"
            offset-y      
            origin="top"
            color="white">
            <template v-slot:activator="{ on }">
              <v-combobox                  
                v-model="dates"
                multiple
                chips
                small-chips
                label="Fecha"
                placeholder="Escoger el día a consultar"
                prepend-inner-icon="event"
                readonly
                box
                color="white"
                v-on="on">
              </v-combobox>
            </template>                      
            <v-date-picker 
              v-model="dates"
              multiple
              no-title
              scrollable
              :first-day-of-week="1"
              locale="es-sp"                        
              :allowed-dates="allowedDates"
              color="blue accent-3"                  
              @input="changesDate">
              <v-spacer></v-spacer>
              <v-btn color="error" @click="menu = false">Cancelar</v-btn>
              <v-btn color="primary" @click="acceptDate1">Aceptar</v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <!-- MENU TIME 1 DATE 1 -->
        <v-flex v-if="showInitialTime">
            <!-- :disabled="eventsLoaded" -->
            <!-- class="mx-1" -->
            <!-- nudge-top="300" -->
            <!-- nudge-left="-10" -->
          <v-menu
            ref="time1Date1Menu"
            lazy
            :close-on-content-click="false"
            v-model="time1Date1Menu"
            transition="scale-transition"
            offset-x
            right
            full-width
            min-width="290px"
            origin="top left"
            :return-value.sync="time1Date1">
              <!-- :disabled="eventsLoaded" -->
            <v-text-field
              slot="activator"
              label="Hora Inicial"
              placeholder="Seleccionar Hora"
              v-model="time1Date1"
              prepend-inner-icon="av_timer"
              readonly
              box
              hide-details
              color="white"
            />
            <v-time-picker 
              v-model="time1Date1"
              format="24hr"
              scrollable
              color="teal darken-1"
              header-color="grey darken-4"
              @input="changeTime1">
              <!-- @change="$refs.time1Date1Menu.save(time1Date1)" -->
              <v-spacer></v-spacer>
              <v-btn color="error" @click="time1Date1Menu = false">Cancelar</v-btn>
              <v-btn color="primary" @click="acceptTime1">Aceptar</v-btn>
            </v-time-picker>
          </v-menu>
        </v-flex>
        <!-- TIME 2 DATE 1 MENU -->
        <v-flex v-if="showFinalTime" mt-3>
            <!-- :disabled="eventsLoaded" -->
            <!-- class="mx-1" -->
            <!-- nudge-top="-15" -->
          <v-menu
            ref="time2Date1Menu"
            lazy
            :close-on-content-click="false"
            v-model="time2Date1Menu"
            transition="scale-transition"
            offset-x
            right
            full-width
            min-width="290px"
            origin="top left"
            :return-value.sync="time2Date1">
              <!-- :disabled="eventsLoaded" -->
            <v-text-field
              slot="activator"
              label="Hora Final"
              placeholder="Seleccionar Hora"
              v-model="time2Date1"
              prepend-inner-icon="av_timer"
              readonly
              box
              hide-details
              color="white"
            />
            <v-time-picker 
              v-model="time2Date1"
              format="24hr"
              scrollable
              :allowed-hours="allowedHours"
              :allowed-minutes="allowedMinutes"
              color="red darken-1"
              header-color="grey darken-4"
              @click:hour="hourClicked"
              @change="changeTime2">
              <!-- @change="$refs.time2Date1Menu.save(time2Date1)" -->
              <v-spacer></v-spacer>
              <v-btn color="error" @click="time2Date1Menu = false">Cancelar</v-btn>
              <v-btn color="primary" @click="$refs.time2Date1Menu.save(time2Date1)">Aceptar</v-btn>
            </v-time-picker>

          </v-menu>
        </v-flex>
      </v-flex>
      <!-- BUTTON -->
      <v-flex class="text-xs-center" my-3 pb-3>
          <!-- :href="urlReportPoint" -->
        <v-btn
          :disabled="reportPointDisabled"
          @click="downloadPointReport" 
          target="_blank"
          color="primary"
          block
          :loading="$loading.isLoading('generatingPointReport')"
        >
          <v-icon left>cloud_download</v-icon>
          Generar Reporte
        </v-btn>
      </v-flex>
    </v-flex>
    <!-- RIGHT SIDE -->
    <v-flex ml-3 my-2 pr-3>
      <!-- MAP -->
      <gmap-map
        class="map-style mb-1"
        :center="center"
        :zoom="zoom"
        @center_changed="changes"
        :options="mapOptions">
        <gmap-marker
          :position="newCenter"
          :icon="selectPointMarker">
        </gmap-marker>
        <gmap-circle
          :center="newCenter"
          :radius="radius"
          :options="circleOptions">
        </gmap-circle>
      </gmap-map>
    </v-flex>
  </v-flex>
</template>

<script>
  import mapOptions from '../../utils/mapOptions.js'
  import {SELECT_POINT_MARKER} from '../../utils/staticsRef'
  import { mapActions } from 'vuex'

  export default {
    name: 'report-by-point',
    data() {
      return {
        latRules: [
          v => !!v || 'Latitud Requerida'
        ],
        lngRules: [
          v => !!v || 'Longitud Requerida'
        ],
        showInitialTime: false,
        showFinalTime: false,
        urlReportPoint: '',
        onlyDate1: null,
        onlyDate2: null,
        date1: null,
        date2: null,
        limitTime: null,
        limitHour: null,
        limitMinute: null,
        time1Date1Menu: false,
        time1Date1: null,
        time2Date1Menu: false,
        time2Date1: null,
        dates: [],
        menu: false,
        radius: 500,
        circleOptions: {
          strokeColor: '#1E88E5',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#2196F3',
          fillOpacity: 0.35
        },
        center: {
          lat: 6.254790211409118,
          lng: -75.551029793457
        },
        newCenter: {
          lat: 6.254790211409118,
          lng: -75.551029793457
        },
        zoom: 13,
        mapOptions,
        selectPointMarker: SELECT_POINT_MARKER
      }
    },
    computed: {
      pointSelectedLat: {
        get() {
          return this.newCenter.lat
        },
        set(value) {
          this.newCenter.lat = Number(value)
          this.center.lat = Number(value)
        }
      },
      pointSelectedLng: {
        get() {
          return this.newCenter.lng
        },
        set(value) {
          this.newCenter.lng = Number(value)
          this.center.lng = Number(value)
        }
      },
      reportPointDisabled() {
        let result = true
        if (this.dates.length === 1 && this.time1Date1 && this.time2Date1) result = false
        return result
      }
    },
    methods: {
      ...mapActions([
        'getPointReport',
        'showMap',
        'addInitPosition'
      ]),
      changeTime2() {
        // console.log('CHANGE TIME 2', this.time1Date1, this.time2Date1)
        // const startTime = this.$moment(this.time1Date1, 'HH:mm')
        // const finalTime = this.$moment(this.time2Date1, 'HH:mm')
        // console.log('startTime: ', startTime)
        // console.log('finalTime: ', finalTime)
        // const differenceTime = this.$moment(startTime).diff(finalTime, 'hours')
        // console.log('DIFF: ', differenceTime)
      },
      acceptDate1() {
        this.$refs.menu.save(this.dates)
        this.time1Date1 = '00:00'
        this.showInitialTime = true
      },
      acceptTime1() {
        this.$refs.time1Date1Menu.save(this.time1Date1)
        this.time2Date1 = this.time1Date1
        this.showFinalTime = true
      },
      hourClicked(value) {
        // console.log('HOUR CLICKED', value)
      },
      downloadPointReport() {
        const payload = {
          date1: this.date1,
          date2: this.date2,
          lat: this.newCenter.lat,
          lng: this.newCenter.lng,
          radius: this.radius
        }
        // console.log('DOWNLOAD POINT REPORT: ', payload)
        this.getPointReport(payload)
      },
      changes(event) {
        this.newCenter.lat = event.lat()
        this.newCenter.lng = event.lng()
      },
      changesDate() {
        // console.log('CHANGE DATE')
        if (this.dates.length === 0) {
          this.showInitialTime = false
          this.showFinalTime = false
          this.onlyDate1 = null
          this.onlyDate2 = null
          this.date1 = null
          this.date2 = null
          this.limitTime = null
          this.limitHour = null
          this.limitMinute = null
          this.time1Date1Menu = false
          this.time1Date1 = null
          this.time2Date1Menu = false
          this.time2Date1 = null
        }
      },
      changeTime1() {
        // console.log('CHANGE TIME 1')
        this.time2Date1 = null
      },
      allowedMinutes(value) {
        // console.log('allowedMinutes', value, this.time2Date1)
        if (this.time2Date1 !== null) {
          const selectedHour = this.time2Date1.split(':')
          // console.log('selectedHour: ', Number(selectedHour[0]), Number(this.limitHour))
          if (Number(selectedHour[0]) === Number(this.limitHour)) {
            // console.log('********* ', value, this.limitMinute)
            if (value <= this.limitMinute) return true
            else return false
          }
        }
        return true
      },
      allowedHours(value) {
        // console.log('allowedHours', value, this.time1Date1)
        const myDate = `${this.dates[0]} ${this.time1Date1}`
        this.date1 = this.$moment(myDate).format('YYYY-MM-DD HH:mm:ss')

        if (this.time2Date1) {
          const selectedHour1 = this.time1Date1.split(':')
          const selectedHour2 = this.time2Date1.split(':')
          let myDate2 = null
          // console.log('selectedHour2 time2Date1', Number(selectedHour2[0]), this.onlyDate1, this.onlyDate2)
          // console.log(this.onlyDate1 !== this.onlyDate2)
          // console.log(Number(selectedHour2[0]) < Number(selectedHour1[0]))

          if (Number(selectedHour2[0]) < Number(selectedHour1[0]) && this.onlyDate1 !== this.onlyDate2) myDate2 = `${this.onlyDate2} ${this.time2Date1}`
          else myDate2 = `${this.dates[0]} ${this.time2Date1}`

          // console.log('MY DATE 2: ', myDate2)

          this.date2 = this.$moment(myDate2).format('YYYY-MM-DD HH:mm:ss')
          // console.log('DATE 2: ', this.date2)
        }
        // console.log('MY DATE: ', myDate)
        const selectedHour = this.$moment(myDate).format('H')
        // console.log('selectedHour', selectedHour)
        const oneAfter = this.$moment(myDate).add(1, 'hours').format('H')
        this.limitTime = this.$moment(myDate).add(2, 'hours').format('YYYY-MM-DD HH:mm:ss')
        this.onlyDate1 = this.$moment(myDate).format('YYYY-MM-DD')
        this.onlyDate2 = this.$moment(myDate).add(2, 'hours').format('YYYY-MM-DD')
        // console.log('ONLY DATE 2: ', this.onlyDate2)
        this.limitHour = this.$moment(this.limitTime).format('H')
        this.limitMinute = this.$moment(this.limitTime).format('mm')
        // console.log('oneAfter: ', oneAfter)
        // console.log('limitTime: ', this.limitTime)
        // console.log('limitHour: ', this.limitHour)
        // console.log('limitMinute: ', this.limitMinute)
        if (value === Number(selectedHour) || value === Number(oneAfter) || value === Number(this.limitHour)) {
          // console.log('VALUE: ', value)
          return true
        } else return false
      },
      allowedDates(date) {
        let today = this.$moment.now()
        let datesResult = this.$moment(date).isBefore(today)
        today = this.$moment(today).format('YYYY-MM-DD')

        if (this.dates.length === 1) datesResult = date === this.dates[0]

        return datesResult
      }
    },
    created() {
      this.mapOptions.scrollwheel = false
    },
    activated() {
      this.mapOptions.scrollwheel = false
    },
    deactivated() {
      this.mapOptions.scrollwheel = true
    }
  }
 </script>
 
 <style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500

h4
  font-size 21px
  font-weight 500

b
  color #BDBDBD

.height-1
  height 50px  

.radius-style
  background-color #616161
  border-radius 2px
  height 80px

.radius-text
  min-width 50px
  max-width 50px

.slider-style
  margin-top -25px

.map-style
  width: 100%
  min-height: 100%

.section-1
  min-width 390px
  max-width 390px

.section-2
  width 100%
  height calc(100vh - 200px)
  margin-left 10px
  margin-right 10px
  
.general-bg
  background-color #424242
  border-radius 3px   
	 
 </style>


// WEBPACK FOOTER //
// src/components/Reports/ReportByPoint.vue